import React from 'react';

import './index.scss'

import {
	MdOutlineCheckCircle,
	MdOutlineLocationOn,
	MdOutlineMail,
	MdOutlinePhone,
} from 'react-icons/md';



const Contact = () => {
    return (
        <div className="contact page">
           <h1>Contact</h1>
		   <div className="contact__wrapper">
		  
				<div className="contact__blocks">

					<div className="contact__block">
						<MdOutlineLocationOn />
						<div>Ukraine</div>
					</div>

					<div className="contact__block">
						<MdOutlinePhone />
						<div>+38 066 955-23-46</div>
					</div>

					<div className="contact__block">
						<MdOutlineMail />
						<div>duminskiy@gmail.com</div>
					</div>

					<div className="contact__block">
						<MdOutlineCheckCircle />
						<div>Freelance Available</div>
					</div>

				</div>

				<div className="contact__info">
					<div className="h1">Github 
						<div className="small">
							<a href="https://github.com/andrey-dum">https://github.com/andrey-dum</a>
						</div>
					</div> 
					<div className="h1">LinkedIn 
						<div className="small">
							<a href="https://www.linkedin.com/in/andrey-duminskiy-a36ba414a/">https://www.linkedin.com/in/andrey-duminskiy-a36ba414a/</a>
						</div>
					</div> 
					<div className="h1">Telegram 
						<div className="small">
							<a href="https://t.me/andreydum">https://t.me/andreydum</a>
						</div>
					</div> 
				</div>
			</div>
        </div>
    );
}

export default Contact;
